"use client";

import { useEffect } from "react";
import { persistUtm, readUtmFromUrl } from "@/lib/utm";

export function UtmCapture() {
  useEffect(() => {
    const fromUrl = readUtmFromUrl(window.location.search);
    if (Object.keys(fromUrl).length > 0) {
      persistUtm(fromUrl);
    }
  }, []);

  return null;
}
